export enum ErrorType {
  UNAUTHORIZED = 401,
  PERMISSION_ERROR = 403,
  PAGE_NOT_FOUND = 404,
  SERVER_ERROR = 500,
}
